export default __webpack_public_path__ + "static/shareableapps-logo-dfb5c4f26841f107683fe3171fdcc1c6.png";